import { Skeleton } from 'antd';

import type { FC } from 'react';

import './FooterSkeleton.scss';

const ACTION_BUTTON_WIDTHS = [120, 140, 100];
const TASK_ROWS_COUNT = 2;

export const FooterSkeleton: FC = () => (
  <div className="FooterSkeleton" aria-busy="true" aria-live="polite">
    <div className="FooterSkeleton__actions">
      {ACTION_BUTTON_WIDTHS.map((width, index) => (
        <Skeleton.Button
          className="FooterSkeleton__action"
          active
          size="default"
          style={{ width }}
          key={index}
        />
      ))}
    </div>

    <div className="FooterSkeleton__tasks">
      <Skeleton.Input
        className="FooterSkeleton__tasks-title"
        active
        size="small"
      />
      <div className="FooterSkeleton__tasks-list">
        {Array.from({ length: TASK_ROWS_COUNT }, (_, index) => (
          <Skeleton.Button
            className="FooterSkeleton__task-row"
            active
            size="default"
            block
            key={index}
          />
        ))}
      </div>
    </div>

    <div className="FooterSkeleton__composer">
      <Skeleton.Input
        className="FooterSkeleton__integration"
        active
        size="small"
      />
      <Skeleton.Input
        className="FooterSkeleton__textarea"
        active
        size="large"
        block
      />
      <div className="FooterSkeleton__composer-actions">
        <Skeleton.Button
          className="FooterSkeleton__composer-icon"
          active
          size="default"
          shape="square"
        />
        <Skeleton.Button
          className="FooterSkeleton__composer-icon"
          active
          size="default"
          shape="square"
        />
        <Skeleton.Button
          className="FooterSkeleton__composer-send"
          active
          size="default"
          style={{ width: 140 }}
        />
      </div>
    </div>
  </div>
);
